export default __webpack_public_path__ + "static/media/cascada-lodge.062b5a56.jpg";